/** Per-route title and meta description for `_app.js` (exact path keys, no query). */
export const SEO_BY_PATH = {
  "/": {
    title: "Fort Worth Family Law Attorneys | Dally & Webb",
    description:
      "Fort Worth family law attorneys focused on divorce, custody, support, and complex family law disputes. Trusted, compassionate, and strategic representation.",
  },
  "/attorneys": {
    title: "Our Attorneys | Dally & Webb Family Law",
    description:
      "Meet the attorneys at Dally & Webb Family Law, PLLC and learn about their background, experience, and commitment to families in Fort Worth.",
  },
  "/attorneys/brewington": {
    title: "Max Brewington | Fort Worth Family Law Attorney | Dally & Webb",
    description:
      "Max Brewington is a Fort Worth family law attorney at Dally & Webb Family Law, PLLC, representing clients in divorce, custody, support, and related matters.",
  },
  "/attorneys/copp": {
    title: "Laura E. Copp | Fort Worth Family Law Attorney | Dally & Webb",
    description:
      "Laura E. Copp is a Fort Worth family law attorney at Dally & Webb Family Law, PLLC, helping clients navigate divorce, custody, and family law disputes.",
  },
  "/attorneys/dally": {
    title: "Lori E. Dally | Fort Worth Family Law Attorney | Dally & Webb",
    description:
      "Lori E. Dally is a Fort Worth family law attorney at Dally & Webb Family Law, PLLC, with experience in divorce, custody, child support, and mediation.",
  },
  "/attorneys/hixon": {
    title: "Lakyn M. Hixon | Fort Worth Family Law Attorney | Dally & Webb",
    description:
      "Lakyn M. Hixon is a Fort Worth family law attorney at Dally & Webb Family Law, PLLC, advising clients on divorce, custody, support, and CPS matters.",
  },
  "/attorneys/king": {
    title: "J. Steven King, Of Counsel | Dally & Webb Family Law",
    description:
      "J. Steven King, Of Counsel at Dally & Webb Family Law, PLLC, brings experience in complex family law and litigation for Fort Worth-area clients.",
  },
  "/attorneys/vargas": {
    title: "Sara Vargas | Fort Worth Family Law Attorney | Dally & Webb",
    description:
      "Sara Vargas is a Fort Worth family law attorney at Dally & Webb Family Law, PLLC, representing clients in divorce, custody, support, and modifications.",
  },
  "/attorneys/webb": {
    title: "Daniel P. Webb | In Memoriam | Dally & Webb Family Law",
    description:
      "In memoriam: Daniel P. Webb, board-certified Fort Worth family law attorney remembered for his dedication to clients and the Dally & Webb firm.",
  },
  "/practice-areas": {
    title: "Practice Areas | Dally & Webb Family Law",
    description:
      "Explore Dally & Webb's family law practice areas including divorce, child custody, child support, adoption, mediation, and more in Fort Worth.",
  },
  "/practice-areas/adoption": {
    title: "Adoption Lawyer Fort Worth | Dally & Webb Family Law",
    description:
      "Fort Worth adoption guidance from Dally & Webb Family Law, PLLC. We help families understand Texas adoption steps, rights, and court requirements.",
  },
  "/practice-areas/child-custody": {
    title: "Child Custody Attorney Fort Worth | Dally & Webb",
    description:
      "Fort Worth child custody attorneys explain conservatorship, possession, geographic restrictions, and temporary orders. Dally & Webb advocates for parents.",
  },
  "/practice-areas/child-protective-services": {
    title: "CPS Defense Attorney Fort Worth | Dally & Webb Family Law",
    description:
      "Child Protective Services (CPS) matters in Texas need prompt legal help. Dally & Webb Family Law represents Fort Worth families in CPS-related cases.",
  },
  "/practice-areas/child-support": {
    title: "Child Support Lawyer Fort Worth | Dally & Webb Family Law",
    description:
      "Fort Worth child support counsel from Dally & Webb: guidelines, modifications, enforcement, and court orders. Protect your children's financial support.",
  },
  "/practice-areas/collaborative-divorce": {
    title: "Collaborative Divorce Fort Worth | Dally & Webb Family Law",
    description:
      "Collaborative divorce can reduce conflict in Texas dissolutions. Dally & Webb Family Law helps Fort Worth clients explore cooperative divorce options.",
  },
  "/practice-areas/contested-divorce": {
    title: "Contested Divorce Attorney Fort Worth | Dally & Webb",
    description:
      "Contested divorce in Texas requires skilled litigation and negotiation. Dally & Webb Family Law represents Fort Worth clients in high-conflict divorce.",
  },
  "/practice-areas/grandparent-rights": {
    title: "Grandparents' Rights Lawyer Fort Worth | Dally & Webb",
    description:
      "Texas grandparent access and custody issues are fact-specific. Dally & Webb Family Law advises Fort Worth grandparents on rights and court options.",
  },
  "/practice-areas/mediation": {
    title: "Family Law Mediation Fort Worth | Dally & Webb",
    description:
      "Mediation can resolve divorce and custody disputes without trial. Dally & Webb Family Law supports Fort Worth clients through structured settlement talks.",
  },
  "/practice-areas/military-divorce": {
    title: "Military Divorce Attorney Fort Worth | Dally & Webb",
    description:
      "Military divorce involves unique jurisdiction and benefits questions. Dally & Webb Family Law guides Fort Worth service members and spouses in Texas.",
  },
  "/practice-areas/modification": {
    title: "Custody & Support Modification Fort Worth | Dally & Webb",
    description:
      "Modify Texas custody or child support when circumstances change materially. Dally & Webb Family Law represents Fort Worth parents in modification suits.",
  },
  "/practice-areas/paternity": {
    title: "Paternity Attorney Fort Worth | Dally & Webb Family Law",
    description:
      "Establish or challenge paternity under Texas law. Dally & Webb Family Law helps Fort Worth parents with rights, duties, custody, and support orders.",
  },
  "/practice-areas/protective-orders": {
    title: "Protective Orders Attorney Fort Worth | Dally & Webb",
    description:
      "Safety and protective orders in family violence cases need urgent legal strategy. Dally & Webb Family Law assists Fort Worth clients with Texas PO matters.",
  },
  "/practice-areas/same-sex-divorce": {
    title: "Same-Sex Divorce Lawyer Fort Worth | Dally & Webb",
    description:
      "Same-sex divorce and family law in Texas. Dally & Webb Family Law provides respectful, experienced representation for Fort Worth LGBTQ+ families.",
  },
  "/practice-areas/termination-of-parental-rights": {
    title: "Termination of Parental Rights | Fort Worth | Dally & Webb",
    description:
      "Termination of parental rights cases are high-stakes under Texas law. Dally & Webb Family Law represents Fort Worth clients with clear, strategic counsel.",
  },
  "/practice-areas/uncontested-divorce": {
    title: "Uncontested Divorce Lawyer Fort Worth | Dally & Webb",
    description:
      "Even agreed Texas divorces need proper petitions and decrees. Dally & Webb Family Law helps Fort Worth couples finalize uncontested divorce correctly.",
  },
  "/contact-us": {
    title: "Contact Us | Dally & Webb Family Law",
    description:
      "Contact Dally & Webb Family Law, PLLC to schedule a consultation with a Fort Worth family law attorney.",
  },
  "/about-us": {
    title: "About Us | Dally & Webb Family Law",
    description:
      "Learn about Dally & Webb Family Law, PLLC and our approach to helping families navigate difficult legal transitions.",
  },
  "/memoriam": {
    title: "In Memoriam: Daniel P. Webb | Dally & Webb",
    description:
      "A memorial page honoring Daniel P. Webb and his enduring legacy in family law and the Fort Worth community.",
  },
};
